import Swiper from 'swiper';
import UiHelper from './UiHelper';
import overlaySlideTemplate from '../../../templates/overlay-slide.tpl';

const selectors = {
    toggle: '.js-overlay-slider-trigger',
    slider: {
        wrap: '.js-overlay-slider',
        prev: '.js-overlay-slider__prev',
        next: '.js-overlay-slider__next',
        close: '.js-overlay-slider__close'
    }
}

class OverlaySliderFactory
{
    static init()
    {
        this.overlaySliders = {};

        Array.from(UiHelper.getNodes(selectors.toggle)).forEach(toggle =>
        {
            toggle.addEventListener('click', e => {
                e.preventDefault();
                this.showOverlaySlider(e.currentTarget);
            });
        });

    }

    static showOverlaySlider(clickedToggle)
    {
        const id = clickedToggle.dataset.gallery;

        // collect all gallery images
        const toggles = Array.from(document.querySelectorAll(`[data-gallery="${id}"]`));

        const initialSlide = toggles.indexOf(clickedToggle);

        if (this.overlaySliders[`g${id}`] === undefined)
        {
            // set html
            this.overlaySliders[`g${id}`] = `<div class="js-overlay-slider swiper-container overlay-slider" id="overlay-slider-${id}">
                <div class="swiper-wrapper overlay-slider__slider">
                    ${
                        toggles.map(toggle => overlaySlideTemplate({
                            srcSet: toggle.dataset.osSrcset,
                            maxImageWidth: toggle.dataset.osMaxImgWidth,
                            figCaption: toggle.dataset.osCaption || '',
                            figDescription: toggle.dataset.osDescription || '',
                            figCopyright: toggle.dataset.osCopyright || '',
                            imgAlt: toggle.dataset.osAlt,
                            blogUrl: window.blogUrl
                        })).join('')
                    }
                </div>
                <button class="js-overlay-slider__prev overlay-slider__prev"><svg role="img" class="icon icon--arrow-left"><use xlink:href="${blogUrl}/wp-content/themes/HU_2017/assets/img/sprite.svg#arrow-left"/></svg></button>
                <button class="js-overlay-slider__next overlay-slider__next"><svg role="img" class="icon icon--arrow-right"><use xlink:href="${blogUrl}/wp-content/themes/HU_2017/assets/img/sprite.svg#arrow-right"/></svg></button>
                <button class="js-overlay-slider__close overlay-slider__close"><svg role="img" class="icon icon--x-thin"><use xlink:href="${blogUrl}/wp-content/themes/HU_2017/assets/img/sprite.svg#x-thin"/></svg></button>
            </div>`;
        }

        document.body.insertAdjacentHTML('beforeend', this.overlaySliders[`g${id}`]);
        new OverlaySlider(document.querySelector(`#overlay-slider-${id}`), initialSlide);
    }
}
export default OverlaySliderFactory;

class OverlaySlider
{
    constructor(wrap, initialSlide=0)
    {
        this.wrap = wrap;
        this.swiper = new Swiper(wrap, {
            speed: 500,
            loop: true,
            initialSlide
        });

        this.prevBtns = wrap.querySelectorAll(selectors.slider.prev);
        this.nextBtns = wrap.querySelectorAll(selectors.slider.next);
        this.closeBtns = wrap.querySelectorAll(selectors.slider.close);


        Array.from(this.prevBtns).forEach(prev =>
        {
            prev.addEventListener('click', e => {
                console.log('click');
                e.stopPropagation(); // prevent bubble up to wrap
                this.swiper.slidePrev();
            });
        });
        Array.from(this.nextBtns).forEach(next =>
        {
            next.addEventListener('click', e => {
                e.stopPropagation(); // prevent bubble up to wrap
                this.swiper.slideNext();
            });
        });
        Array.from(this.closeBtns).forEach(close =>
        {
            close.addEventListener('click', e => {
                this.swiper.destroy();
                this.wrap.parentNode.removeChild(this.wrap);
            });
        });

        // also close from bg
        // this.wrap.addEventListener('click', e => {
        //     //this.swiper.destroy();
        //     this.wrap.parentNode.removeChild(this.wrap);
        // });
        // stop propagation from images to prevent bubble up to wrap
        Array.from(this.wrap.querySelectorAll('img')).forEach(img =>
        {
            img.addEventListener('click', e => {
                e.stopPropagation(); // prevent bubble up to wrap
            });
        });
    }
}
